<template>
    <div>
        <div class="d_wrap_searchbar_power">
            <div class="d_wrap_input_search_bar d-md-flex flex-md-row justify-content-between align-items-center">
                <div class="col-md-7 d_wrap_input_search d-flex flex-row justify-content-between align-items-center">
                    <input class="d_input_search col-md-12" type="text" placeholder="Search English"
                           :value="wordLookup" @keyup.stop="updateCurrentWordLookup($event.target.value)">
                    <span class="d_division_box d-none d-xs-block"></span>
                </div>
                <div class="col-md-4 d_wrap_select_dictionary d-flex flex-row justify-content-between cursor_pointer">
                    <span class="d_wrap_select_type_dictionary">
                        Oxford Dictionary
                    </span>
                    <span class="d_icon_show_more_type_dictionary">
                        <i class="fas fa-chevron-down"></i>
                    </span>
                </div>
                <div class="col-md-1 d_search_button cursor_pointer d-inline-flex flex-row justify-content-center align-items-center"
                     @click="clickSearchWord">
                    <i class="fas fa-search"></i>
                </div>
            </div>

            <div class="d_wrap_select_mode_search">
                <div class="d-flex flex-row">
                    <span class="d_wrap_label_dictionary_type cursor_pointer">
                        Oxford Dictionary
                    </span>
                    <span class="d_wrap_label_dictionary_type cursor_pointer">
                        Cambridge Dictionary
                    </span>
                    <span class="d_wrap_label_dictionary_type cursor_pointer">
                        Từ điển Anh - Việt
                    </span>
                    <span class="d_wrap_label_dictionary_type cursor_pointer">
                        Từ đồng nghĩa
                    </span>
                </div>
            </div>

        </div>

    </div>
</template>

<script>

    export default {
        name: 'SearchBarPower',
        components: {},
        props: {},
        data: function () {
            return {
                wordLookup: ''
            }
        },
        mounted() {
            // this.wordText = this.$route.query['word']
        },
        methods: {
            updateCurrentWordLookup(word) {
                // let word = this.wordLookup.trim()
                if (word != null && word !== '' && word !== this.$store.getters.currentWordLookup) {
                    console.log(word)
                    this.$store.dispatch('updateCurrentWordLookup', word)
                }
            },
            clickSearchWord() {
                let word = this.wordLookup
                if (word != null && word !== '' && word.trim() !== this.$store.getters.currentWordLookup) {
                    // console.log(word.trim())
                    this.$store.dispatch('updateCurrentWordLookup', word.trim())
                }
            }
        }
    }
</script>

<style scoped>
    @import "../../../assets/css/dictionary/searchbar.css";
</style>
